import {
  FETCH_INSIGHTS,
  FETCH_INSIGHTS_SUCCESS,
  FETCH_INSIGHTS_ERROR,
  CLEAR_INSIGHTS,
  UPDATE_PROCESSING_STAGE
} from '../actions/insights';
import { PROCESSING_STAGES } from '../constants';

const initialState = {
  insights: {},
  loading: {},
  errors: {},
  processingStage: {}
};

/**
 * Parses markdown content into structured insights
 */
const parseInsights = (content) => {
  if (!content) return [];
  
  const sections = content.split('##').filter(Boolean);
  return sections.map(section => {
    const [title, ...contentLines] = section.trim().split('\n');
    const content = contentLines.join('\n').trim();
    
    return {
      title: title.trim(),
      content: content
    };
  });
};

export default function insightsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INSIGHTS:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.eventId]: true
        },
        errors: {
          ...state.errors,
          [action.payload.eventId]: null
        }
      };

    case FETCH_INSIGHTS_SUCCESS:
      // console.log('Reducer: Fetch Success', {
      //   eventId: action.payload.eventId,
      //   hasResponse: !!action.payload.insights,
      //   hasContent: !!action.payload.insights?.content,
      //   fromCache: !!action.payload.insights?.debugInfo?.fromCache
      // });

      // Ensure we have valid insights with content
      if (!action.payload.insights?.content) {
        const error = new Error('Invalid insights format: missing content');
        error.details = {
          response: action.payload.insights,
          eventId: action.payload.eventId
        };
        console.error('Invalid insights format:', error.details);
        return {
          ...state,
          loading: {
            ...state.loading,
            [action.payload.eventId]: false
          },
          errors: {
            ...state.errors,
            [action.payload.eventId]: error
          }
        };
      }

      try {
        return {
          ...state,
          insights: {
            ...state.insights,
            [action.payload.eventId]: action.payload.insights
          },
          loading: {
            ...state.loading,
            [action.payload.eventId]: false
          },
          errors: {
            ...state.errors,
            [action.payload.eventId]: null
          }
        };
      } catch (error) {
        const errorState = {
          message: 'Failed to process insights',
          details: {
            originalError: error,
            eventId: action.payload.eventId,
            response: action.payload.insights
          },
          eventId: action.payload.eventId,
          timestamp: new Date().toISOString()
        };
        console.error('Error processing insights:', errorState);
        return {
          ...state,
          loading: {
            ...state.loading,
            [action.payload.eventId]: false
          },
          errors: {
            ...state.errors,
            [action.payload.eventId]: errorState
          }
        };
      }

    case FETCH_INSIGHTS_ERROR:
      // console.log(' Reducer: Processing Fetch Error', {
      //   action: {
      //     type: action.type,
      //     eventId: action.payload.eventId,
      //     error: {
      //       name: action.payload.error?.name,
      //       message: action.payload.error?.message,
      //       stack: action.payload.error?.stack,
      //       cause: action.payload.error?.cause,
      //       details: action.payload.error?.details
      //     }
      //   },
      //   currentState: {
      //     loading: state.loading[action.payload.eventId],
      //     hasError: !!state.errors[action.payload.eventId],
      //     errorType: typeof state.errors[action.payload.eventId]
      //   }
      // });
      
      // Ensure we have a valid error object
      const error = action.payload.error || new Error('Unknown error occurred');
      const errorState = {
        message: error.message || 'Unknown error occurred',
        details: error.details || {
          originalError: error,
          eventId: action.payload.eventId,
          timestamp: new Date().toISOString()
        },
        eventId: action.payload.eventId,
        timestamp: new Date().toISOString()
      };

      // console.log(' Reducer: Setting error state:', errorState);
      
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.eventId]: false
        },
        errors: {
          ...state.errors,
          [action.payload.eventId]: errorState
        },
        processingStage: {
          ...state.processingStage,
          [action.payload.eventId]: null // Clear processing stage on error
        }
      };

    case UPDATE_PROCESSING_STAGE:
      // console.log(' Reducer: Updating processing stage', {
      //   eventId: action.payload.eventId,
      //   stage: action.payload.stage,
      //   timestamp: new Date().toISOString()
      // });
      
      return {
        ...state,
        processingStage: {
          ...state.processingStage,
          [action.payload.eventId]: action.payload.stage in Object.values(PROCESSING_STAGES) ? action.payload.stage : null
        }
      };

    case CLEAR_INSIGHTS:
      const { [action.payload.eventId]: _, ...restInsights } = state.insights;
      const { [action.payload.eventId]: __, ...restLoading } = state.loading;
      const { [action.payload.eventId]: ___, ...restErrors } = state.errors;
      const { [action.payload.eventId]: ____, ...restStages } = state.processingStage;
      
      return {
        ...state,
        insights: restInsights,
        loading: restLoading,
        errors: restErrors,
        processingStage: restStages
      };

    default:
      return state;
  }
}